import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import CookieConsent from "react-cookie-consent";
import Cookies from 'js-cookie'
import axios from 'axios'
import { setCableGdprConfirmationUpdated } from 'virtual_congress/exhibition_actions'

export default function CookieConsentBanner({children, ...props}) {

  const dispatch = useDispatch()
  const cookieAcceptionUrl = useSelector(state => state.cookieAcceptionUrl)
  const useCookieStore = useSelector(state => state.serverSettings?.tracking_cookie_store)
  const gdprBannerRequired = useSelector(state => state.serverSettings?.tracking_gdpr_required)
  const existingGdprStatus = useSelector(state => useCookieStore ? Cookies.get("gdprstatus") : state.gdprConfirmation)

  const sendSelection = (accepted) => {

    if(useCookieStore) {
      console.log("Saving gdpr cookie", accepted)
      Cookies.set("gdprstatus", accepted.toString())
      dispatch(setCableGdprConfirmationUpdated(true))
    } else {
      console.error("Saving gdpr to server", accepted)
        axios({
          url: cookieAcceptionUrl,
          method: "put",
          data: {
            acception: accepted
          }
        }).then(response => {
          console.log("cookie_acception_response", response)
        }).catch(ex => console.error(ex)) 
      }
    }

  // console.log({gdprBannerRequired})
  // console.log({existingGdprStatus})
  // console.log("Cookies.get(gdprstatus)", Cookies.get("gdprstatus"))

  if(!gdprBannerRequired || existingGdprStatus)
    return null

  return <>
      <CookieConsent debug={true} onAccept={() => sendSelection(true)} onDecline={() => sendSelection(false)} {...props}>
        {children}
      </CookieConsent>
    </>
}
